<template>
  <div class="w-full lg:grid lg:grid-cols-1 min-h-[100vh] pt-14 sm:pt-0">
    <div class="flex items-center justify-center py-12 sm:pt-[150px]">
      <div class="mx-auto grid w-full p-4 sm:p-0 sm:w-[390px] gap-14">
        <div class="grid gap-2 text-center">
          <div class="flex flex-col items-center gap-4 mx-auto mb-2">
            <img src="https://dashboard.hoopay.com.br/img/hoopay-logo.png" alt="Logo Hoopay"
              class="max-h-[50px] w-auto object-contain" />
            <h1 class="text-3xl font-bold">
              Área de Membros
            </h1>
          </div>
          <!-- <h1 class="text-3xl font-bold">
            Login
          </h1> -->
          <p class="text-muted-foreground">
            Digite seu email e senha abaixo para fazer login
          </p>
        </div>
        <div class="grid gap-4">
          <div class="grid gap-2">
            <Label for="email">Email</Label>
            <Input id="email" type="email" placeholder="ex: email@exemplo.com" required v-model="loginPayload.email" />
          </div>
          <div class="grid gap-2">
            <div class="flex items-center">
              <Label for="password">Senha</Label>
              <RouterLink :to="{ name: 'auth.password-recovery' }" class="ml-auto inline-block text-sm">
                Esqueceu sua senha?
              </RouterLink>
            </div>
            <div class="relative items-center">
              <Input id="password" :type="showPassword ? 'text' : 'password'" required v-model="loginPayload.password"
                class="pr-10" />
              <button type="button" @click="showPassword = !showPassword"
                class="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-muted-foreground hover:text-foreground transition-colors">
                <Eye v-if="!showPassword" class="h-4 w-4" />
                <EyeOff v-else class="h-4 w-4" />
              </button>
            </div>
          </div>
          <Button type="submit" class="w-full py-6 mt-6" :disabled="isAuthLoading" @click="login(
            loginPayload,
            (res) => {
              if (res.data.is2AF) {
                return $router.push({ name: 'auth.2fa' })
              }

              if (isTradersPlatform) {
                $router.push({ name: 'trader.home' })
              } else {
                $router.push({ name: 'courses.my' })
              }
            },
            () => toast({
              title: 'Login falhou',
              description: 'credenciais inválidas!',
              variant: 'destructive'
            })
          )">
            <Loader2 v-if="isAuthLoading" class="w-4 h-4 mr-2 animate-spin" />
            Entrar
          </Button>
        </div>
        <div class="mt-4 text-center text-sm">
          Não tem uma conta?
          <RouterLink :to="{ name: 'register' }" class="underline">
            Cadastrar-se
          </RouterLink>
        </div>
      </div>
    </div>
    <p v-if="isTradersPlatform" class="text-center text-xs pb-10">© 2024 Traders Cup Brasil 29.435.748/0001-07. Todos os
      direitos reservados.</p>
    <!-- <div class="hidden bg-muted lg:block">
      <img
        src="https://www.shadcn-vue.com/placeholder.svg"
        alt="Image"
        width="1920"
        height="1080"
        class="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
      >
    </div> -->
  </div>
  <Toaster />
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useToast } from '@/components/ui/toast/use-toast'
import { Toaster } from '@/components/ui/toast'
import { onMounted, ref } from 'vue'
import { Loader2, Eye, EyeOff } from 'lucide-vue-next'
import { useAuth } from '@/composables/useAuth'
import { useTenant } from '@/composables/useTenant'

const { toast } = useToast()
const loginPayload = ref({ email: '', password: '' })
const showPassword = ref(false)
const { login, isAuthLoading } = useAuth()
const { tenantLogo, initializeTenant, isTradersPlatform } = useTenant()

onMounted(() => {
  initializeTenant()
})
</script>